<template>
  <div id="alm">
    <el-card
      shadow="hover"
      class="mainCard clear-card"
    >
      <div class="content">
        <div class="name">
          Taylor Lee
        </div>
        <div class="slogan">
          Inspire Courage to Succeed
        </div>
        <el-row
          type="flex"
          :gutter="5"
        >
          <el-col class="tasksPanel">
            <div class="title task">
              Tasks
            </div>
            <el-row
              class="subRow"
              type="flex"
              :gutter="5"
            >
              <el-col
                v-for="(task, key) in tasks"
                :key="key"
                :span="12"
              >
                <el-card class="subCard">
                  <div class="label">
                    {{ task.label }}
                  </div>
                  <div class="image">
                    <img
                      v-if="task.image"
                      :src="require(`@/assets/alm/${task.image}`)"
                      alt="Icon"
                    />
                  </div>
                  <div class="explanation">
                    {{ task.explanation }}
                  </div>
                  <div class="explanationList">
                    <ul>
                      <li
                        v-for="(item, key2) in task.explanationList"
                        :key="key2"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-col>
          <el-col class="peoplePanel">
            <div class="title people">
              People
            </div>
            <el-row
              class="subRow"
              type="flex"
              :gutter="5"
            >
              <el-col
                v-for="(person, key) in people"
                :key="key"
                :span="8"
              >
                <el-card class="subCard">
                  <div class="label">
                    {{ person.label }}
                  </div>
                  <div class="image">
                    <img
                      v-if="person.image"
                      :src="require(`@/assets/alm/${person.image}`)"
                      alt="Icon"
                    />
                  </div>
                  <div class="explanation">
                    {{ person.explanation }}
                  </div>
                  <div class="explanationList">
                    <ul>
                      <li
                        v-for="(item, key2) in person.explanationList"
                        :key="key2"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tasks: [
        {
          label: 'Assure success',
          image: 'Icons-1.png',
          explanation: 'I expect my team members to improve organizational quality and to assure success through:',
          explanationList: [
            'Settings inspirational goals, taking initiative, and following through',
            'High level of operating discipline (governance, business process, compliance)',
            'Execution with excellence, culture of accountability',
            'Continuous innovation across entire business model (Currency, Competition, Cost, Customers, Channels)',
          ],
        },
        {
          label: 'Continuous Change',
          image: 'Icons-2.png',
          explanation: 'Self-Actualizing is constant life-change hence:',
          explanationList: [
            'Create the future rather than record history',
            'Learning agility: based on insatiable curiosity',
            'Leverage technology, be ahead of the pack',
            'Develop yourself and shape your future',
            'Demonstrate courage',
            'Ask forgiveness rather than permission',
            'Be your best you everyday',
          ],
        },
      ],
      people: [
        {
          label: 'Engaging People',
          image: 'Icons-3.png',
          explanation: 'My commitmentto leading & developing people & partnership is to:',
          explanationList: [
            'Set an inspirational vision for the future',
            'Lead from the front',
            'Coach people to take responsibility for their business',
            'Remove barriers to enable people to succeed',
            'Engage coworkers on the journey',
            'Help transform problems into solutions',
          ],
        },
        {
          label: 'Boundary-less inclusion',
          image: 'Icons-4.png',
          explanation: 'Build trust and reduce boundaries in work process through:',
          explanationList: [
            'Empower & coach people to reach their goals',
            'Engage people personally',
            'Embrace globalization and diversity',
          ],
        },
        {
          label: 'Communication',
          image: 'Icons-5.png',
          explanation: 'Behavior = Communication therefore:',
          explanationList: [
            'Honesty, integrity, earn trust',
            'Engage coworkers and (over) communicate',
            'Shared understanding of current reality and vision',
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
#alm {
  .name {
    text-align: left;
    font-weight: bold;
  }

  .slogan {
    text-align: left;
    font-weight: bold;
    font-size: 25px;
  }

  .tasksPanel {
    width: 40%;
  }

  .peoplePanel {
    width: 60%;
  }

  .title {
    color: white;
    margin: 5px 0;
    line-height: 35px;
    border-radius: 4px;

    &.task {
      background-color: #52a9dc;
    }

    &.people {
      background-color: #477bba;
    }
  }

  .subRow {
    height: calc(100% - 45px); // 45px = title line-height + margin top & bottom
  }

  .el-card.subCard {
    text-align: left;
    height: 100%;

    .label {
      text-align: center;
      font-weight: bold;
      height: 45px;
    }

    .image {
      text-align: center;

      img {
        max-width: 100%;
      }
    }

    .explanation {
      font-size: 12px;
      font-style: italic;
    }

    .explanationList {
      font-size: 12px;

      ul {
        padding-left: 10px;

        li {
          margin-bottom: 15px;
        }
      }
    }
  }
}
</style>
